export const MARKER_WIDTH_METERS = 14;
export const MARKER_TEXTURE_WIDTH = 128;
export const MARKER_TEXTURE_HEIGHT = 128;
export const ICON_CENTER_Y = 64;
export const ICON_CENTER_X = MARKER_TEXTURE_WIDTH / 2;
export const ICON_RADIUS = 48;
export const ICON_STROKE_WIDTH = 5;
export const ICON_PATH_SCALE = 2;
export const ICON_SHADOW_COLOR = "#18233d";
export const ICON_SHADOW_BLUR = 2;
export const MARKER_POLE_HEIGHT = 12;
const MAX_ICON_PIXELS = 48;
export const LABEL_SHOW_ICON_PIXELS = 26;
export const LABEL_HIDE_ICON_PIXELS = 22;
export function trimmedPoleHeight(
  screenLength: number,
  clearance: number,
  baseDepth: number,
  tipDepth: number
) {
  if (screenLength <= clearance || baseDepth <= 0 || tipDepth <= 0) return 0;
  const fraction = 1 - clearance / screenLength;
  return (
    (MARKER_POLE_HEIGHT * fraction * baseDepth) / (tipDepth * (1 - fraction) + fraction * baseDepth)
  );
}
export function markerDimensions(depth: number, projectionY: number, viewportHeight: number) {
  if (depth <= 0 || projectionY <= 0 || viewportHeight <= 0) return null;
  const pixelsPerMeter = (projectionY * viewportHeight) / (2 * depth);
  const iconRatio = (2 * ICON_RADIUS) / MARKER_TEXTURE_WIDTH;
  const width = Math.min(MARKER_WIDTH_METERS, MAX_ICON_PIXELS / (pixelsPerMeter * iconRatio));
  const height = (width * MARKER_TEXTURE_HEIGHT) / MARKER_TEXTURE_WIDTH;
  return {
    width,
    height,
    iconPixels: width * pixelsPerMeter * iconRatio,
  };
}
